export function ftName(fn, ln) {
    return `${ [ fn || "", ln || "" ].filter(Boolean).join(" ") }` || "-";
}

export function fRecipientName(fn, ln) {
    return `${ [ fn || "", ln || "" ].filter(Boolean).join(" ") }` || "-";
}

export function getAvatarName(fullName) {

    // 中文：取第一个汉字作为“姓氏”展示
    const chineseMatch = fullName?.match(/[\u4E00-\u9FFF]/);
    if (chineseMatch) return chineseMatch[0];

    // 非中文：按空格分词，取每个词的首字母
    // 例："john smith" -> JS, "wstest1test kk" -> WK, "wstest1" -> W

    // 按空格分割成数组，取每个元素的首字母
    const words = fullName?.split(' ')?.filter(Boolean);
    const initials = words?.map((word) => word?.[0])?.join('');

    return initials?.toUpperCase() || '?';
}